import React from "react";
import { Row } from "react-bootstrap";

function Vision() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
    <h1 className="project-heading" style={{ paddingBottom: "10px" }}>
      <strong className="purple">Visión</strong>
    </h1>
    <p className="home-about-body">
    Trabajar para ayudar a los usuarios y a las
    empresas a desarrollar su potencial en el ámbito
    administrativo y contable.
    </p>
  </Row>
  );
}

export default Vision;
